import { Fragment } from "react";

import useTableRow from "./UseTableRow";
import useTableTopRow from "./UseTableTopRow";

import tableStyle from '../../Table.module.css';

/**
 * Styling component for the top most row of a table.
 * Aligns it's children to the left while spacing them evenly(group elements inside a span to make them stick together).
 * Also displays the number of results in the table.
 * @param {Number} colSpan number of columns the top row will span
 */
const Top = ({ colSpan, showDataTotal = true, dataTotal = 0, dataName = 'Results', className = '',
  style = undefined, children }) => {
  const { sortedDataTotal } = useTableTopRow();

  return (
    <tr className={[tableStyle.Top, className].join(' ')} style={style}>
      <td colSpan={colSpan}>
        <div className={tableStyle.Flex}>
          {children}
          {showDataTotal === true &&
            <p style={{ placeSelf: 'flex-end' }}>
              {dataTotal !== 0 && dataTotal !== sortedDataTotal
                ? `Showing ${sortedDataTotal} of ${dataTotal} ${dataName}`
                : `${sortedDataTotal} ${dataName}`
              }
            </p>
          }
        </div>
      </td>
    </tr>
  );
}

/**
 * Styling component for rows that are selectable.
 * @param {Number} rowId unique id of the row, i.e. person.personId
 */
const Select = ({ rowId, className = '', style = undefined, children }) => {
  const { isSelected } = useTableRow(rowId);

  return (
    <tr className={[className, isSelected === true ? tableStyle.Selected : ''].join(' ')} style={style}>
      {children}
    </tr>
  );
};

/**
 * Functional component for rows that contain a nested table.
 * NOTE: Any onClick methods used by buttons in this row should include e.stopPropagation(). 
 * @param {JSX.Element} nestedTable the table to display when the row is expanded
 * @param {Number} rowId unique id of the row, i.e. person.personId 
 * @param {Number} tableColSpan number of columns the nested table will span
 */
const Accordion = ({ nestedTable, rowId, tableColSpan, tableColOffsetStart = 0, tableColOffsetEnd = 0, className = '',
  style = undefined, children }) => {
  const { isExpanded, isSelected, onRowClicked } = useTableRow(rowId);

  return (
    <Fragment>
      <tr onClick={onRowClicked} className={[className, tableStyle.Accordion, isSelected === true ? tableStyle.Selected : ''].join(' ')} style={style}>
        {children}
      </tr>
      {isExpanded === true && (
        <tr className={[tableStyle.Expanded].join(' ')}>
          {tableColOffsetStart > 0 && <td colSpan={tableColOffsetStart} />}
          <td colSpan={tableColSpan}>{nestedTable}</td>
          {tableColOffsetEnd > 0 && <td colSpan={tableColOffsetEnd} />}
        </tr>
      )}
    </Fragment>
  );
};

export { Accordion, Select, Top };